export enum GaTrackingStringConstantEnum {
  Yes = 'yes',
  No = 'no',
  VolumePrice = 'volume price',
  RegularPrice = 'regular price',
  EUR = 'EUR',
  NoEECLabel = 'No Label',
  Carousel = 'carousel',
}

export enum offerTypes {
  cheapest = 'cheapest',
  other = 'other',
}
